import React, { MouseEvent } from 'react';

import { makeClassNames } from '../../../utils/styles';
import './menu-item.scss';

const STATE_SELECTED = 'selected';
const STATE_NOT_SELECTED = 'not-selected';

export interface IMenuItem {
  id: number;
  label: string;
  isSelected?: boolean;
  hasFocus?: boolean;
  href?: string;
  callback?: (event: MouseEvent, id: number) => any;
}

const classNames = () =>
  makeClassNames({
    menuItem: 'menu-item',
  });

// TODO: LC 2020-07-20 - I can't use JS FUNCTION DEFAULT VALUES because they are REQUIRED in both TS INTERFACE and REACT PROPTYPES!
// To preserve CODE COVERAGE I use the ugly "istanbul ignore next" statement
const MenuItem = ({
  /* istanbul ignore next: default value on mandatory field */ label = '',
  /* istanbul ignore next: default value on mandatory field */ callback = () => {},
  href,
  id,
  isSelected = false,
}: IMenuItem) => {
  const cn = classNames();

  return (
    <button
      type="button"
      className={cn.menuItem}
      value={href}
      data-state={isSelected ? STATE_SELECTED : STATE_NOT_SELECTED}
      onClick={(event: MouseEvent) => callback(event, id)}
      role="option"
      aria-controls={label.toLowerCase().replace(/ /g, '-')}
      aria-label={label}
    >
      {label}
    </button>
  );
};

export default MenuItem;
